import React, { useEffect, useState } from "react";
import { Grid } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { get, has, uniq } from "lodash";
import { TABLE_PAGESIZE } from "../../constants";
import { getGridColumns, trimLower } from "../../utils/general";
import {
  DETAIL,
  TARGET,
  OVERVIEW,
  TEMPLATE,
} from "../../constants/routeConstants";
import { updateGridFilterMutation } from "../../graphQL/mutation/gridFilters";
import { useMutation } from "@apollo/client";
import { checkArrayLength } from "src/utils";
import { useHistory } from "react-router";

const GridTable = (props) => {
  const { filter, isTargetOpenInNewTab, isTargetTemplate, apiOnRowRender } = props;
  const isPageable = props.isPageable ? props.isPageable : false;
  const history = useHistory();
  const [result, setResult] = useState([]);
  const [dataState, setDataState] = useState({
    take: TABLE_PAGESIZE,
    skip: props.currentPage ? props.currentPage : 0,
  });
  const [dataStateEvent, setDataStateEvent] = useState({});
  const [dataStateUpdated, setDataStateUpdated] = useState({});
  const [updateFilterMutation] = useMutation(updateGridFilterMutation);

  useEffect(() => {
    setDataStateEvent({});
    setDataStateUpdated({});
  }, []);

  const createDataState = (data, dataState1) => {
    if (data.length) {
      setResult(
        props?.toBeSpliceData
          ? process(data.slice(0), {
              filter: dataState1.filter,
              sort: dataState1.sort,
            }).data
          : process(data.slice(0), dataState1)
      );
      setDataState(dataState1);
    }
  };

  useEffect(() => {
    if (props.data) {
      createDataState(props.data, {
        take: props.take,
        skip: props.currentPage ? props.currentPage : 0,
      });
    }
  }, [props.data]);

  const updateDataState = (_dataState) => {
    const tempDataState = { ..._dataState };
    const filteredData = process(props?.data || [], {
      ..._dataState,
      take: props.take,//(props?.data || []).length,
      skip: props.skip//0,
    });

    if (tempDataState && tempDataState.filter) {
      tempDataState.filter.filters = get(
        tempDataState,
        "filter.filters",
        []
      ).map((subFilter) => {
        subFilter.filters = get(subFilter, "filters", []).map((i) => {
          switch (i.field) {
            case "fullName":
              const creatorId = uniq(
                filteredData.data.map((c) => {
                  const iCreatorName =
                    `${c.createdBy?.firstName} ${c.createdBy?.lastName}`.toLowerCase();
                  if (iCreatorName === i.value.toLowerCase()) {
                    return c.createdBy.id;
                  }
                })
              ).filter((cid) => cid && cid !== null);
              return {
                ...i,
                creatorId,
              };
            case "coaches":
              return {
                ...i,
                coachId: uniq(
                  filteredData.data
                    .map((c) => {
                      const coachNames = c.coaches
                        .split(",")
                        .map((k) => k.trim());
                      return c.coachTarget.map((obj) => {
                        if (coachNames.includes(obj.coach.firstName)) {
                          return obj.coachid;
                        }
                      });
                    })
                    .flat()
                ),
              };
            default:
              return {
                ...i,
              };
          }
        });
        return subFilter;
      });
    }
    return tempDataState;
  };

  useEffect(() => {
    updateDataState(dataStateUpdated);
  }, [dataStateUpdated, dataStateEvent]);

  const dataStateChange = (event) => {
    let dataState = event.dataState;
    setDataStateEvent(event);
    setDataStateUpdated(dataState);
    props.setSort && props.setSort(dataState.sort);

    // props.setCurrentPage && props.setCurrentPage(event.dataState.skip);
    createDataState(props.data, event.dataState);
    if (props.kendoGridView) {
      const columns = [...get(event, "target.columnResize.columns", [])];
      props.setKendoGridView({
        ...props.kendoGridView,
        dataState,
        columns: getGridColumns(columns),
      });
    }
  };

  /* const sortChange = event => {
    props.setSort && props.setSort(event.sort);
  }; */

  const onColumnReorder = (event) => {
    if (props.kendoGridView) {
      const columns = [...get(event, "target.columnResize.columns", [])];
      props.setKendoGridView({
        ...props.kendoGridView,
        columns: getGridColumns(columns),
      });

      const dataState = get(props, "kendoGridView.dataState");

      const variables = {
        input: {
          ...props.kendoGridView,
          columns: getGridColumns(columns),
          filterName: get(props, "variables.listFilter.filterName"),
          id: get(props, "variables.listFilter.id"),
          filterKey: trimLower(get(props, "variables.listFilter.filterKey")),
          dataState: JSON.stringify(dataState),
        },
      };

      updateFilterMutation({ variables }).then(({ data }) => {
        const updateFilters = props.gridFilters
          ? props.gridFilters.map(function (item) {
              return item.filterKey === get(variables, "input.filterKey")
                ? {
                    ...item,
                    columns: get(variables, "input.columns"),
                  }
                : item;
            })
          : [];
        props.setGridFilters && props.setGridFilters(updateFilters);
      });
    }
  };
  // const [targetId, setTargetId] = useState("")
  // useEffect(() => {
  //   console.log("...................", apiOnRowRender, targetId)
  //   if(apiOnRowRender && targetId){
  //     apiOnRowRender({id:targetId})
  //   }
  // }, [targetId])
  const rowRender = (trElement, props) => {
    let trProps = {};
    let rowStyle = {};

    if(props?.dataItem?.isNew){
      if(props?.dataItem?.status !== "Completed") {
        rowStyle = { className: "new-row-border new-row-bg" };
      }
      let hasCheckins = checkArrayLength(props?.dataItem?.checkin?.items);
      if (!hasCheckins) {
        rowStyle = { className: "new-row-border new-row-bg disable-arrow" }
      }
    }

    let status = get(props, "dataItem.coachees.status", "");
    if (has(props.dataItem, "selectedCoacheeStatus")) {
      status = get(props, "dataItem.selectedCoacheeStatus", "");
    }
    if (status === "DEACTIVATED" || status === "REACTIVATED") {
      trProps = { className: "grid-disabled-row" };
    }

    // Disable row on enableViewResponse
    let enableViewResponse = get(props, "dataItem.enableViewResponse", "");
    if (enableViewResponse && filter === "All") {
      trProps = { className: "grid-disabled-row" };
    }

    let hasCheckins = checkArrayLength(props?.dataItem?.checkin?.items);
    if (!hasCheckins) {
      trProps = { className: "disable-arrow" };
    }
    // if(apiOnRowRender){
    //   setTargetId(props?.dataItem?.id)
    // }

    if (isTargetOpenInNewTab) {
      const targetDetail = isTargetTemplate
        ? `${TARGET}${TEMPLATE}${DETAIL}/${props.dataItem.id}`
        : `${TARGET}${OVERVIEW}/${props.dataItem.id}`;
      trProps = {
        ...trProps,
        onDoubleClick: () => {
          history.push(targetDetail);
        },
      };
    }
    return React.cloneElement(
      trElement,
      { ...trProps, ...rowStyle },
      trElement.props.children
    );
  };

  const onPageChange = (e) => {
    props.onPageChange
      ? props.onPageChange(e)
      : dataStateChange({ dataState: e.page });
    let gridContainer = document.querySelector(".k-grid-content");
    if (gridContainer) {
      gridContainer.scrollTop = 0;
    }
  };

  return (
    <Grid
      {...dataState}
      data={
        !isPageable
          ? props?.toBeSpliceData
            ? result.slice(props.skip, props.take + props.skip)
            : result
          : props?.data
      }
      // data={!isPageable ? result : props.data}
      onDataStateChange={dataStateChange}
      sortable
      resizable
      scrollable
      reorderable
      rowRender={rowRender}
      onColumnReorder={onColumnReorder}
      onExpandChange={props.onExpandChange}
      expandField={props.expandField}
      detail={props.detail}
      total={props.total}
      onPageChange={onPageChange}
      onFilterChange={props.onFilterChange}
      sort={props.sort}
      skip={props.skip}
      take={props.take}
      pageable={
        !isPageable
          ? {
              buttonCount: 4,
              pageSizes: [10, 25, 50, 100],
            }
          : false
      }
      onRowClick={(e) => {
        if (props.onRowClick) {
          props.onRowClick(e);
        }
      }}
      filterOperators={props.filterOperators}
    >
      {props.children}
    </Grid>
  );
};

export default GridTable;
